import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = { class: "p-text-left" }
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_4 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "linkStyle disabled"
}
const _hoisted_16 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_20 = ["data-testid"]
const _hoisted_21 = {
  key: 3,
  style: {"width":"100%"}
}
const _hoisted_22 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_parentclass = _resolveDirective("parentclass")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "generalRating ch-datatable p-datatable-ssm",
    responsiveLayout: "scroll",
    value: !_ctx.feedbacks ? [] : _ctx.rows,
    showGridlines: "",
    scrollable: true,
    scrollHeight: "25rem"
  }, {
    empty: _withCtx(() => [
      _hoisted_1
    ]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.evaluateSummary === _ctx.EvaluateSummary.Staff
              ? 'Valoraciones del staff a la clase'
              : 'Métricas generales'), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        key: _ctx.ColumnFields.Person,
        frozen: true,
        class: "min-width-200",
        headerClass: "p-d-flex p-jc-center"
      }, {
        body: _withCtx(({ data }) => [
          (!data.gray)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(data[_ctx.ColumnFields.Person]), 1))
            : _createCommentVNode("", true),
          (data.gray && !_ctx.classesMap)
            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6, 512)), [
                [_directive_parentclass, 'bg-gray-400']
              ])
            : (data.gray)
              ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(data[_ctx.ColumnFields.Person]), 1)
                ], 512)), [
                  [_directive_parentclass, 'bg-gray-400']
                ])
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        key: _ctx.ColumnFields.Rating,
        class: "min-width-60",
        headerClass: "p-d-flex p-jc-center"
      }, {
        body: _withCtx(({ data }) => [
          (!data.gray)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {"width":"100%"},
                "data-testid": _ctx.getTestRatingName(data.isFirstRow)
              }, [
                _createTextVNode(_toDisplayString(data[_ctx.ColumnFields.Rating] ? _ctx.truncate(data[_ctx.ColumnFields.Rating]) : ''), 1)
              ], 8, _hoisted_8)), [
                [_directive_parentclass, _ctx.getClassNameByAVGRating(data[_ctx.ColumnFields.Rating])]
              ])
            : _createCommentVNode("", true),
          (data.gray && !_ctx.classesMap)
            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11, 512)), [
                [_directive_parentclass, 'bg-gray-400']
              ])
            : (data.gray)
              ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(data[_ctx.ColumnFields.Rating]), 1)
                ], 512)), [
                  [_directive_parentclass, 'bg-gray-400']
                ])
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateColumns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field,
          class: "min-width-60",
          headerClass: 'p-d-flex p-jc-center'
        }, {
          header: _withCtx(() => [
            (_ctx.evaluateSummary === _ctx.EvaluateSummary.general)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(col.header), 1))
              : (
            _ctx.hasFeedback(
              _ctx.feedbacks,
              col.field,
              _ctx.evaluateSummary,
              _ctx.teacher?.user?.personId
            )
          )
                ? _withDirectives((_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.changeView(col.field)),
                    class: "linkStyle"
                  }, [
                    _createTextVNode(_toDisplayString(col.header), 1)
                  ], 8, _hoisted_14)), [
                    [
                      _directive_tooltip,
                      
            _ctx.classes.find(c => c._id === col.field)?.name || ''
          ,
                      void 0,
                      {
                        top: true,
                        blur: true
                      }
                    ]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [
                    _createTextVNode(_toDisplayString(col.header), 1)
                  ], 512)), [
                    [
                      _directive_tooltip,
                      
            (_ctx.classes.find(c => c._id === col.field)
              ? _ctx.classes.find(c => c._id === col.field)?.name
              : '') + ' (No hay Feedback)'
          ,
                      void 0,
                      {
                        top: true,
                        blur: true
                      }
                    ]
                  ])
          ]),
          body: _withCtx(({ data }) => [
            (data.gray && !_ctx.classesMap)
              ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18, 512)), [
                  [_directive_parentclass, 'bg-gray-400']
                ])
              : (data.gray)
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString(data[col.field] && _ctx.teacher && _ctx.classesMap
              ? `${data[col.field]}/${
                  _ctx.classesMap.get(col.field)?.studentAttendances?.length
                }`
              : ''), 1)
                  ], 512)), [
                    [_directive_parentclass, 'bg-gray-400'],
                    [
                      _directive_tooltip,
                      
            _ctx.evaluateSummary === _ctx.EvaluateSummary.staff
              ? 'Docentes que valoraron por sobre docentes que asistieron'
              : 'Estudiantes que valoraron por sobre estudiantes que asistieron'
          ,
                      void 0,
                      {
                        top: true,
                        blur: true
                      }
                    ]
                  ])
                : (data.isFirstRow)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 2,
                      "data-testid": _ctx.getTestRatingName(data.isFirstRow),
                      style: {"width":"100%"}
                    }, [
                      _createTextVNode(_toDisplayString(data[col.field] ? _ctx.truncate(data[col.field]) : ''), 1)
                    ], 8, _hoisted_20)), [
                      [_directive_parentclass, _ctx.getClassNameByAVGRating(data[col.field])]
                    ])
                  : (
            data[col.field] !== null &&
              col.field !== _ctx.ColumnFields.Person &&
              col.field !== _ctx.ColumnFields.Rating
          )
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_21, [
                        _createTextVNode(_toDisplayString(data[col.field] ? _ctx.truncate(data[col.field]) : ''), 1)
                      ], 512)), [
                        [_directive_parentclass, _ctx.getClassNameByRating(data[col.field])]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(data[col.field] || ''), 1))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}